import React, { Fragment, useEffect, useContext, useState } from "react";
import AddIcon from "../../images/add.svg";
import { Grid, Button } from "@mui/material";
import { Table, TableBody } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Assignments } from "../../types/project";
import AlertDialog from "./popupDialogue";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  InputBase,
} from "@mui/material";
import { FormControl, FilledInput, InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import ProjectContext from "../../context/project/ProjectContext";
import AuthContext from "../../context/auth/AuthContext";
import AddIntelliFiberClients from "./AddIntelliFiberClients";
import AddIntelliFiberClientsProjects from "./AddIntelliFiberClientsProjects";

function IntelliFiberClientsConfiguration() {
  const authContext = useContext(AuthContext);
  let { user } = authContext;
  const {
    // selectedProject,
    intelliFiberUserRoles,
    roles,
    users,
    loading,
    getAllUserRoles,
    deleteUserRoles,
    deleteUserProjects,
    getUserProjects,
  } = useContext(ProjectContext);

  const [showTable, setShowTable] = useState(false);
  const [openAddRoles, setOpenAddRoles] = React.useState(false);
  const [userRoles, setUserRoles] = React.useState<any>([]);
  const [selectedUserRoles, setSelectedUserRoles] = React.useState<any>(null);
  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const [globalSearch, setGlobalSearch] = React.useState("");
  const [filteredUserRoles, setFilteredUserRoles] = React.useState<any>([]);

  const closeDelete = () => {
    setSelectedUserRoles(null);
    setDeleteDialog(false);
  };

  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState({ type: "", msg: "" });

  const closeAlert = () => {
    setAlertMsg({ type: "", msg: "" });
    setShowAlert(false);
  };

  const fetchUserProjects = async (user) => {
    if (getUserProjects) {
      console.log("fetchUserProjects");
      try {
        let res = await getUserProjects(user.UserID, user.RoleID);
        console.log("fetchUserProjects res", res);

        if (res) {
          return res;
        }
      } catch (error) {
        console.log("fetchUserProjects err", error);
      }
    }
  };

  const deleteProjects = async (user) => {
    console.log("deleteProjects props", user);

    let projects = await fetchUserProjects(user);
    projects = projects?.map((ele) => ele.ProjectID);
    console.log("deleteProjects projects", projects);

    if (deleteUserProjects) {
      try {
        let payload = {
          UserID: user.UserID,
          RoleID: user.RoleID,
          Projects: projects,
        };
        console.log("deleteProjects payload", payload);

        const res = await deleteUserProjects(payload);
        console.log("deleteProjects res", res);

        if (res) {
          return res;
        }
      } catch (error) {
        console.log("deleteProjects err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const deleteUser = async (user) => {
    console.log("deleteUser props", user);
    if (deleteUserRoles) {
      try {
        let resp = await deleteProjects(user);
        console.log("deleteUser resp", resp);

        if (resp) {
          let payload = {
            UserID: user.UserID,
            UserRoleID: user.UserRoleID,
          };
          console.log("deleteUser payload", payload);

          const res = await deleteUserRoles(payload);
          console.log("deleteUser res", res);

          if (res) {
            setAlertMsg({ type: "Success", msg: "User successfully deleted" });
            setShowAlert(true);
            setUserRoles([]);
            fetchUserRoles();
            setDeleteDialog(false);
            setSelectedUserRoles(null);
          }
        }
      } catch (error) {
        console.log("deleteUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const editUserRole = (user) => {
    console.log("editUserRole props", user);
    setSelectedUserRoles(user);
    setOpenAddRoles(true);
  };

  const handleShowAddRoles = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setOpenAddRoles(true);
  };

  const handleAddRolesClose = () => {
    setOpenAddRoles(false);
    setSelectedUserRoles(null);
  };

  useEffect(() => {
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      // setShowTable(true);
      // setLocalAssignments(intelliFiberUserRoles);
      console.log(
        "Checking for assignments: ",
        JSON.stringify(intelliFiberUserRoles)
      );
    } else {
      //setShowTable(false);
    }
  }, [intelliFiberUserRoles]);

  useEffect(() => {
    console.log("globalSearch", globalSearch, userRoles);
    let _allProjectsList = {};
    if (globalSearch) {
      Object.keys(userRoles).forEach((item) => {
        if (
          userRoles[item].UserName.toLowerCase().includes(
            globalSearch.toLowerCase()
          )
        ) {
          console.log("globalSearch", item, userRoles[item]);
          _allProjectsList[item] = userRoles[item];
        }
      });
    } else {
      _allProjectsList = { ...userRoles };
    }
    console.log("globalSearch", _allProjectsList);
    // let sortList =  Object.keys(userRoles).sort((ele)=>{

    // })
    setFilteredUserRoles(_allProjectsList);
  }, [userRoles, globalSearch]);

  const fetchUserRoles = async () => {
    if (getAllUserRoles) {
      setShowTable(false);
      setUserRoles([]);
      console.log("fetchUserRoles");
      try {
        const _userRoles = await getAllUserRoles();
        console.log("fetchUserRoles res", _userRoles);

        const groupUsers = _userRoles.reduce((map, item) => {
          if (!map[item.LoginID]) {
            console.log("fetchUserRoles item", item);
            map[item.LoginID] = { ...item };
            map[item.LoginID].allProjects = [];
          }
          if (
            item.ProjectID &&
            item.ProjectID !== null &&
            item.ProjectName !== null
          ) {
            map[item.LoginID].allProjects.push({
              projectName: item.ProjectName,
              projectID: item.ProjectID,
            });
          }
          return map;
        }, {});

        console.log("fetchUserRoles groupUsers", groupUsers);

        setUserRoles(groupUsers);
        setShowTable(true);
      } catch (error) {
        console.log("fetchUserRoles err", error);
        setShowTable(false);
      }
    }
  };

  useEffect(() => {
    // console.log(`Project list updated V2: ${JSON.stringify(selectedProject)}`);
    fetchUserRoles();
    console.log(`Project: assignments:`, intelliFiberUserRoles);
    console.log(`Project: roles:`, roles);
    console.log(`Project: users:`, users);
  }, []);

  return (
    <Fragment>
      {openAddRoles && (
        <AddIntelliFiberClients
          showDialog={openAddRoles}
          selectedUserRoles={selectedUserRoles}
          userRoles={userRoles}
          handleClose={handleAddRolesClose}
          refresh={fetchUserRoles}
        />
      )}
      <Dialog open={showAlert} onClose={closeAlert}>
        <DialogTitle>{alertMsg.type}</DialogTitle>
        <DialogContent>{alertMsg.msg}</DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closeAlert}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteDialog} onClose={closeDelete}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>Are you sure you want to delete?</DialogContent>
        <DialogActions>
          <Button onClick={closeDelete}>No</Button>
          <Button
            variant="contained"
            onClick={() => deleteUser(selectedUserRoles)}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Grid
        container
        rowSpacing={2}
        columnSpacing={4}
        justifyContent="space-between"
        sx={{ mx: 2, marginBottom: 2, height: "15vh" }}
      >
        <Grid item>
          <Button
            sx={{ maxHeight: "50px" }}
            onClick={handleShowAddRoles}
            color="secondary"
            variant="contained"
          >
            <img src={AddIcon} alt="Add User" />
            Add User
          </Button>
        </Grid>
        <Grid item sm={4} sx={{ mx: 4 }}>
          <Paper
            component="form"
            sx={{
              my: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Login Id"
              value={globalSearch}
              onChange={(e) => setGlobalSearch(e.target.value)}
            />

            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
      {showTable ? (
        <Grid container sx={{ mx: 2, px: 2, minHeight: "50vh" }}>
          <TableContainer
            component={Paper}
            sx={{
              mx: 2,
              px: 2,
              // maxHeight: "50vh",
            }}
          >
            <Table aria-label="role table" stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: "large" }} align="center">
                    Login Id
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align="center">
                    Client Group
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }} align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!filteredUserRoles
                  ? null
                  : Object.keys(filteredUserRoles).map((item) => (
                      <TableRow key={userRoles[item].UserID}>
                        <TableCell align="center">
                          {userRoles[item].LoginID}
                        </TableCell>
                        <TableCell align="center">
                          {userRoles[item].GroupName}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <IconButton color="primary">
                            <EditIcon
                              onClick={() => editUserRole(userRoles[item])}
                            />
                          </IconButton>
                          <IconButton color="primary">
                            <DeleteIcon
                              onClick={() => {
                                setSelectedUserRoles(userRoles[item]);
                                setDeleteDialog(true);
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid
          container
          className="center-pane"
          justifyContent="center"
          sx={{ mx: 2, px: 2 }}
        >
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            {loading ? "Loading...Please wait!" : "No Records Found"}
          </div>
        </Grid>
      )}
    </Fragment>
  );
}

export default IntelliFiberClientsConfiguration;
